import api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";
const state = {
    smsList: [],
   
    smsForm:{
        id:0,
        message:"",
        sendDate:"",
        userFullName:"",
        shopName:"",
        phoneNumber:"",
       
    }
     
};
const getters = {
    smsList(state) {
        // state.usersList.map((user) => {
        //     user.roles.map((role, index) => {
        //         switch(role) {
        //             case 'Admin': user.roles[index] = 'المدير';
        //             break;
        //             case 'Shop': user.roles[index] = 'المشتركون';
        //             break;
        //             case 'Contact': user.roles[index] = 'التواصل';
        //             break;
        //             case 'Offer': user.roles[index] = 'العروض والإعلانات';
        //             break;
        //             case 'Subscription': user.roles[index] = 'الإشتراكات';
        //             break;
        //         }   
        //     }) 
        // })
        return state.smsList;
    },
  
    smsForm(state) {
        return state.smsForm;
    }
};
const mutations = {
    GET_SMS_ITEMS(state, payload) {
    
        state.smsList = payload;
   
        store.dispatch('setLoading', false);
    },
    ADD_SMS_ITEMS(state, payload) {
       
        store.dispatch('setLoading', false);
    },
   
  
};
const actions = {
    async fetchSMS(context) {
        const { data } = await api.query(`/api/Notification/GetSMSRecords`).then((data) => data);
        context.commit("GET_SMS_ITEMS", data);
    },

    async createSMSRecord(context, payload) {
        store.dispatch('setLoading', true);
        const { data } = await api
            .post(`/api/Notification/SendUserSMS?Number=${payload.phoneNumber}&Message=${payload.message}`)
            .then((data) => data);
           
        if (typeof data === 'string') {
            context.commit("ERROR_MESSAGE", data);
        } else {
            context.commit("ADD_SMS_ITEMS", data);
        }
    },
 
    
};

const smsRecord = { state, getters, mutations, actions };

export default smsRecord;
